module.exports = __webpack_public_path__ + "static/media/green.3811c6b2.png";